import { render, staticRenderFns } from "./AssignCaliberAssistant.vue?vue&type=template&id=4b52de88"
import script from "./AssignCaliberAssistant.vue?vue&type=script&lang=js"
export * from "./AssignCaliberAssistant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports